import { gql } from '@apollo/client';

export const QUERY_EIM_EXECUTIVE_DASHBOARD_V2_COUNTRY_METRICS = gql`
    query eimExecutiveDashboardV2CountryMetrics($request: EIMExecutiveDashboardV2Request!) {
        eimExecutiveDashboardV2CountryMetrics(request: $request) {
            country
            companyCode
            intake {
                totalProcessed
                inboundCount
                outboundCount
            }
            processing {
                stpRate
                onTimeRate
                avgTransitDays
                inTransitCount
            }
            exceptions {
                failedCount
                overdueCount
                failureRate
            }
            coverage {
                activePartners
                totalPartners
                coverageRate
            }
        }
    }
`;

export const QUERY_EIM_EXECUTIVE_DASHBOARD_V2_COUNTRY_DETAIL = gql`
    query eimExecutiveDashboardV2CountryDetail($request: EIMExecutiveDashboardV2Request!) {
        eimExecutiveDashboardV2CountryDetail(request: $request) {
            metrics {
                totalProcessed
                successfulCount
                failedCount
                overdueCount
                inTransitCount
                stpRate
                failureRate
                avgTransitDays
            }
            topPartners {
                partnerno
                direction
                partnerName
                company
                total
            }
            hourlyTrend {
                hourLabel
                successfulCount
                failedCount
            }
            topErrorMessages {
                direction
                message
                count
                percentage
            }
        }
    }
`;
